<template>
  <div class="d-flex">
    <div  class="user-content">
      <p class="nav-user-data">{{ userData.fname }} {{ userData.lname }} </p>
      <p class="nav-user-data">{{ userData.companyName }} </p>
    </div>
  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'

export default {
  mixins: [authMixin]
}
</script>
